var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            "WFA" === _vm.param.flowStatus
              ? _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.GLOBAL.ANSWERERS")))])
              : _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.POPUP.SEARCH.USER")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "div",
              { staticClass: "grid_wrap only_grid" },
              [
                _c("toast-grid", {
                  key: _vm.gridKey,
                  ref: _vm.gridId,
                  attrs: {
                    gridId: _vm.gridId,
                    columns: _vm.columns,
                    data: _vm.gridData,
                    options: _vm.options,
                    pageOptions: _vm.pageOptions,
                    isTotalCount: true
                  },
                  on: { mouseover: _vm.onMouseover }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60d66e86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d66e86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/userListPopup.vue
// module id = j/48
// module chunks = 0